import { render, staticRenderFns } from "./CamaraEnVivoPantalla.vue?vue&type=template&id=2dfa136e&scoped=true&"
import script from "./CamaraEnVivoPantalla.vue?vue&type=script&lang=ts&"
export * from "./CamaraEnVivoPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraEnVivoPantalla.vue?vue&type=style&index=0&id=2dfa136e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa136e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2dfa136e', component.options)
    } else {
      api.reload('2dfa136e', component.options)
    }
    module.hot.accept("./CamaraEnVivoPantalla.vue?vue&type=template&id=2dfa136e&scoped=true&", function () {
      api.rerender('2dfa136e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/EnVivo/CamaraEnVivoPantalla.vue"
export default component.exports